import React, { FC } from "react";
import { StyledRowDiv } from "./DoorList";
import getCornerImgWidth from "../../../util/getCornerImgWidth";
import { UnitObj } from "../../../util/quoteCartStorage";

interface Props {
  isSmallScreen: boolean;
  door: UnitObj;
}

const ImageLayout: FC<Props> = ({ isSmallScreen, door }) => {
  if (isSmallScreen) {
    const minWidth = 200;

    if (door.doorType.includes("Corner")) {
      const height = 100;

      const widthLeftCorner = getCornerImgWidth(height, door.exactConfig);
      const widthRightCorner = getCornerImgWidth(
        height,
        door.cornerConfigRight || "",
      );

      return (
        <StyledRowDiv style={{ minWidth }}>
          <StyledRowDiv>
            <img
              style={{
                width: widthLeftCorner,
                height,
              }}
              src={door.exactConfigImg}
              alt=""
            />
            <img
              style={{
                width: widthRightCorner,
                height,
              }}
              src={door.exactConfigImgRightCorner}
              alt=""
            />
          </StyledRowDiv>
        </StyledRowDiv>
      );
    }

    if (door.doorType.includes("Combo")) {
      return (
        <StyledRowDiv style={{ minWidth }}>
          <StyledRowDiv style={{alignItems: "flex-start"}}>
            <img
              style={{
                width: "auto",
                height: door.comboUnitLeft === "Door" ? 100 : 52,
              }}
              src={
                door.comboUnitLeft === "Door"
                  ? door.exactConfigImg
                  : door.exactConfigImgRightCorner
              }
              alt=""
            />
            <img
              style={{
                width: "auto",
                height: door.comboUnitRight === "Door" ? 100 : 52,
              }}
              src={
                door.comboUnitRight === "Door"
                  ? door.exactConfigImg
                  : door.exactConfigImgRightCorner
              }
              alt=""
            />
          </StyledRowDiv>
        </StyledRowDiv>
      );
    }

    if (
      door.doorType.includes("Window") &&
      !door.doorType.includes("Bi-fold") &&
      door.material === "All Aluminum"
    ) {
      return (
        <StyledRowDiv style={{ minWidth }}>
          <img
            style={{
              width: "auto",
              height: 120,
              paddingRight: 10,
              marginLeft: 40,
            }}
            src={door.exactConfigImg}
            alt=""
          />
        </StyledRowDiv>
      );
    }

    if (door.doorType === "Fixed Panel") {
      return (
        <StyledRowDiv style={{ minWidth }}>
          <img
            style={{
              width: 55,
              height: 120,
              paddingRight: 10,
              marginLeft: 40,
            }}
            src={door.exactConfigImg}
            alt=""
          />
        </StyledRowDiv>
      );
    }

    return (
      <StyledRowDiv style={{ minWidth }}>
        <img
          style={{
            width: 200,
            height: door.doorType === "Bi-fold Window" ? 80 : 120,
          }}
          src={door.exactConfigImg}
          alt=""
        />
      </StyledRowDiv>
    );
  }

  const parentStyle = { minWidth: 300, paddingRight: 10 };

  if (door.doorType.includes("Corner")) {
    const height = Number(door.numberOfPanels) >= 10 ? 90 : 115;

    const widthLeftCorner = getCornerImgWidth(height, door.exactConfig);
    const widthRightCorner = getCornerImgWidth(
      height,
      door.cornerConfigRight || "",
    );

    return (
      <StyledRowDiv style={parentStyle}>
        <StyledRowDiv>
          <img
            style={{
              width: widthLeftCorner,
              height,
            }}
            src={door.exactConfigImg}
            alt=""
          />
          <img
            style={{
              width: widthRightCorner,
              height,
            }}
            src={door.exactConfigImgRightCorner}
            alt=""
          />
        </StyledRowDiv>
      </StyledRowDiv>
    );
  }

  if (door.doorType.includes("Combo")) {
      return (
        <StyledRowDiv style={{...parentStyle, width: 360}}>
          <StyledRowDiv style={{alignItems: "flex-start"}}>
            <img
              style={{
                width: "auto",
                height: door.comboUnitLeft === "Door" ? 90 : 47,
                paddingRight: 5
              }}
              src={
                door.comboUnitLeft === "Door"
                  ? door.exactConfigImg
                  : door.exactConfigImgRightCorner
              }
              alt=""
            />
            <img
              style={{
                width: "auto",
                height: door.comboUnitRight === "Door" ? 90 : 47,
                paddingLeft: 5
              }}
              src={
                door.comboUnitRight === "Door"
                  ? door.exactConfigImg
                  : door.exactConfigImgRightCorner
              }
              alt=""
            />
          </StyledRowDiv>
        </StyledRowDiv>
      );
    }

  if (
    door.doorType.includes("Window") &&
    !door.doorType.includes("Bi-fold") &&
    door.material === "All Aluminum"
  ) {
    return (
      <StyledRowDiv style={parentStyle}>
        <img
          style={{
            width: "auto",
            height: 150,
            paddingRight: 10,
            marginLeft: 40,
          }}
          src={door.exactConfigImg}
          alt=""
        />
      </StyledRowDiv>
    );
  }

  if (door.doorType === "Fixed Panel") {
    return (
      <StyledRowDiv style={parentStyle}>
        <img
          style={{
            width: 70,
            height: 150,
            paddingRight: 10,
            marginLeft: 40,
          }}
          src={door.exactConfigImg}
          alt=""
        />
      </StyledRowDiv>
    );
  }

  return (
    <StyledRowDiv style={parentStyle}>
      <img
        style={{
          width: 250,
          height: door.doorType === "Bi-fold Window" ? 100 : 150,
        }}
        src={door.exactConfigImg}
        alt=""
      />
    </StyledRowDiv>
  );
};

export default ImageLayout;
